"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var snappyjs_1 = require("snappyjs");
var react_1 = require("@monaco-editor/react");
require("../helpers/load-monaco-editor");
var Page_1 = require("./Page");
var Notification_1 = require("./Notification");
var prettyPrint_1 = require("../helpers/prettyPrint");
var components_1 = require("@athena-portal/components");
var RawDataDecompressPage = /** @class */ (function (_super) {
    __extends(RawDataDecompressPage, _super);
    function RawDataDecompressPage(props) {
        var _this = _super.call(this, props) || this;
        _this.onInputChange = function (e) {
            _this.setState({
                inputB64: e.target.value,
                outputText: "",
                showOutputPreview: false,
                error: undefined
            });
        };
        _this.onDecodeClick = function () {
            try {
                var cleaned = _this.state.inputB64.replace(/\s+/g, "").trim();
                if (cleaned.length === 0) {
                    _this.setState({
                        error: "Please paste a Base64 value.",
                        outputText: ""
                    });
                    return;
                }
                var decoded = _this.decompress(cleaned);
                var pretty = (0, prettyPrint_1.prettyPrint)(decoded);
                _this.setState({
                    outputText: pretty,
                    error: undefined,
                    showOutputPreview: true
                });
            }
            catch (err) {
                var message = err instanceof Error ? err.message : "Failed to decode.";
                _this.setState({ error: message, outputText: "" });
            }
        };
        _this.onClearClick = function () {
            _this.setState({
                inputB64: "",
                outputText: "",
                showOutputPreview: false,
                error: undefined
            });
        };
        _this.showOutputPreview = function () {
            _this.setState({ showOutputPreview: true });
        };
        _this.hideOutputPreview = function () {
            _this.setState({ showOutputPreview: false });
        };
        _this.state = {
            inputB64: "",
            outputText: "",
            showOutputPreview: false,
            error: undefined
        };
        return _this;
    }
    RawDataDecompressPage.prototype.render = function () {
        return ((0, jsx_runtime_1.jsx)(Page_1.default, { title: "Raw data decompress", children: this.renderPageContent() }));
    };
    RawDataDecompressPage.prototype.renderPageContent = function () {
        var _a = this.state, inputB64 = _a.inputB64, outputText = _a.outputText, error = _a.error, showOutputPreview = _a.showOutputPreview;
        var canDecode = inputB64.trim().length > 0;
        var canPreviewOutput = outputText.trim().length > 0;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Notification_1.default, { show: showOutputPreview, hide: this.hideOutputPreview, title: "Raw data", fullscreen: true, body: ((0, jsx_runtime_1.jsx)(react_1.default, { height: "60vh", width: "100%", language: this.getEditorLanguage(outputText), value: outputText, options: {
                            readOnly: true,
                            minimap: { enabled: false },
                            wordWrap: "on",
                            scrollBeyondLastLine: false
                        }, onMount: function (editor, monaco) { return editor.focus(); } })), style: {
                        margin: "0 auto",
                        width: "80%",
                        maxWidth: "1000px"
                    } }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("label", { htmlFor: "raw-data-input", children: "Base64 (Snappy-compressed)" }) }), (0, jsx_runtime_1.jsx)("textarea", { id: "raw-data-input", className: "form-control description-textarea", value: inputB64, onChange: this.onInputChange, rows: 6 }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary mt-3", onClick: this.onDecodeClick, disabled: !canDecode, children: "Decode" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-gray mt-3 ml-2", onClick: this.onClearClick, children: "Clear" }), (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-gray mt-3 ml-2", onClick: this.showOutputPreview, disabled: !canPreviewOutput, children: "View output" }), error ? (0, jsx_runtime_1.jsx)("div", { children: error }) : null] })] }));
    };
    RawDataDecompressPage.prototype.decompress = function (base64) {
        var compressedBytes = this.base64ToUint8Array(base64);
        var rawBytes = (0, snappyjs_1.uncompress)(compressedBytes);
        return new TextDecoder("utf-8").decode(rawBytes);
    };
    RawDataDecompressPage.prototype.base64ToUint8Array = function (b64) {
        var clean = b64.replace(/\s+/g, "");
        var binary = window.atob(clean);
        var bytes = new Uint8Array(binary.length);
        for (var i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i);
        }
        return bytes;
    };
    RawDataDecompressPage.prototype.getEditorLanguage = function (value) {
        var trimmed = value.trim();
        if (!trimmed) {
            return "plaintext";
        }
        if (trimmed.startsWith("<")) {
            return "xml";
        }
        try {
            JSON.parse(trimmed);
            return "json";
        }
        catch (_a) {
            return "plaintext";
        }
    };
    RawDataDecompressPage = __decorate([
        components_1.authorize,
        (0, components_1.role)("Administrator", "Pricing"),
        __metadata("design:paramtypes", [Object])
    ], RawDataDecompressPage);
    return RawDataDecompressPage;
}(React.Component));
exports.default = RawDataDecompressPage;
//# sourceMappingURL=RawDataDecompressPage.js.map